 
import getEnvironmentalVariables from './getEnvironmentalVariables';

export const { BASE_URL } = getEnvironmentalVariables();

export const ORGANIZATION_USER_FEATURE_ACCESS_QUERY_KEY = 'OrganizationUserFeatureAccess' as const;

export const FEATURE = {
    DEAL_DOCUMENTS: 'DEAL_DOCUMENTS',
    DEAL_PIPELINE: 'DEAL_PIPELINE',
    REPORTING_ACROSS_DEALS: 'REPORTING_ACROSS_DEALS',
    DEAL_INCOMING_APPROVALS: 'DEAL_INCOMING_APPROVALS',
    BACK_OF_ENVELOPE: 'BACK_OF_ENVELOPE',
    DEAL_DASHBOARD: 'DEAL_DASHBOARD',
    DEAL_REPORT_BUILDER: 'DEAL_REPORT_BUILDER',
    PRO_FORMA: 'PRO_FORMA',
    DEAL_ORGANIZATION_MANAGEMENT: 'DEAL_ORGANIZATION_MANAGEMENT',
    PORTFOLIO_INVOICE_DATA_INDEX: 'PORTFOLIO_INVOICE_DATA_INDEX',
    PORTFOLIO_VENDOR_ANALYTICS: 'PORTFOLIO_VENDOR_ANALYTICS',
    QUICK_ANALYTICS: 'QUICK_ANALYTICS',
    PORTFOLIO_BUDGET_CATEGORIZATIONS: 'PORTFOLIO_BUDGET_CATEGORIZATIONS',
    PORTFOLIO_CAPITAL_PLANNING: 'PORTFOLIO_CAPITAL_PLANNING',
    GLOBAL_COST_FORECAST: 'GLOBAL_COST_FORECAST',
    GLOBAL_COST_FORECAST_V2: 'GLOBAL_COST_FORECAST_V2',
    PORTFOLIO_DEVELOPER_FEE: 'PORTFOLIO_DEVELOPER_FEE',
    PORTFOLIO_COST_ANALYTICS: 'PORTFOLIO_COST_ANALYTICS',
    VENDOR_DIRECTORY: 'VENDOR_DIRECTORY',
    CRM_CONTACTS: 'CRM_CONTACTS',
    CRM_COMPANIES: 'CRM_COMPANIES',
} as const;

export const FEATURE_IDS: { [K in TFeature]: number } = {
    DEAL_PIPELINE: 141,
    REPORTING_ACROSS_DEALS: 142,
    DEAL_INCOMING_APPROVALS: 143,
    BACK_OF_ENVELOPE: 144,
    DEAL_DASHBOARD: 145,
    DEAL_DOCUMENTS: 148,
    DEAL_REPORT_BUILDER: 149,
    PRO_FORMA: 150,
    DEAL_ORGANIZATION_MANAGEMENT: 151,
    CRM_CONTACTS: 152,
    CRM_COMPANIES: 153,
    PORTFOLIO_VENDOR_ANALYTICS: 2,
    PORTFOLIO_COST_ANALYTICS: 3,
    GLOBAL_COST_FORECAST: 4,
    QUICK_ANALYTICS: 5,
    PORTFOLIO_CAPITAL_PLANNING: 80,
    PORTFOLIO_DEVELOPER_FEE: 81,
    GLOBAL_COST_FORECAST_V2: 82,
    PORTFOLIO_INVOICE_DATA_INDEX: 88,
    PORTFOLIO_BUDGET_CATEGORIZATIONS: 89,
    VENDOR_DIRECTORY: 140,
} as const;

export type TFeature = keyof typeof FEATURE;

export const FEATURES_LIST: { [K in TFeature]: string } = {
    DEAL_DOCUMENTS: 'deal_documents',
    DEAL_PIPELINE: 'deal_pipeline',
    REPORTING_ACROSS_DEALS: 'reporting_across_deals',
    DEAL_INCOMING_APPROVALS: 'deal_incoming_approvals',
    BACK_OF_ENVELOPE: 'back_of_envelope',
    DEAL_DASHBOARD: 'deal_dashboard',
    DEAL_REPORT_BUILDER: 'deal_report_builder',
    PRO_FORMA: 'pro_forma',
    DEAL_ORGANIZATION_MANAGEMENT: 'deal_organization_management',
    PORTFOLIO_INVOICE_DATA_INDEX: 'portfolio_invoice_data_index',
    PORTFOLIO_VENDOR_ANALYTICS: 'portfolio_vendor_analytics',
    QUICK_ANALYTICS: 'quick_analytics',
    PORTFOLIO_BUDGET_CATEGORIZATIONS: 'portfolio_budget_categorizations',
    PORTFOLIO_CAPITAL_PLANNING: 'portfolio_capital_planning',
    GLOBAL_COST_FORECAST: 'global_cost_forecast',
    GLOBAL_COST_FORECAST_V2: 'global_cost_forecast_v2',
    PORTFOLIO_DEVELOPER_FEE: 'portfolio_developer_fee',
    PORTFOLIO_COST_ANALYTICS: 'portfolio_cost_analytics',
    VENDOR_DIRECTORY: 'vendor_directory',
    CRM_CONTACTS: 'crm_contacts',
    CRM_COMPANIES: 'crm_companies',
} as const;

export const USER_CLASSES = {
    SUPER_ADMIN: 6,
    CUSTOM: 12,
};

const SELECTED_ORGANIZATION_ID = 'selected_org_id' as const;
export const getUserSpecificSelectedOrgKey = (userId: number) => `${SELECTED_ORGANIZATION_ID}_${userId}`;
